import React from "react"
import { useNavigate } from "react-router"

import downCheron from "../../assets/Header_Icons/downChevron.svg"
import { useDarkMode } from "../../context/DarkModeContext"

const Profile = () => {
    const navigate = useNavigate()
    const { isDarkMode } = useDarkMode()
    
    const logoutApp = () => {
        localStorage.setItem("selectedLanguage", "en")
        sessionStorage.clear()
        localStorage.clear()
        navigate("/")
    }
    const { roles, user_details }  = sessionStorage.getItem("userDetails")
        ? JSON.parse(sessionStorage.getItem("userDetails"))
        : ""
    const userDetails = user_details?.user_name ? user_details?.user_name : 
        `${user_details?.first_name} ${user_details?.last_name}`
    return (
        <div className="flex items-center justify-center gap-2 cursor-pointer">
            <div className="flex flex-col justify-center items-start">
                <span className="text-sm font-semibold text-secondary-50 dark:text-white">
                    { userDetails } 
                </span>
                <span className="text-xs font-medium text-secondary-200 dark:text-white">{ roles }</span>
                <div className="flex flex-col justify-center items-start">
                    <span className="text-xs font-semibold text-secondary-50 dark:text-white" aria-hidden="true" onClick={ logoutApp }>{ "Logout" }</span>
                </div>
            </div>
            <div>
                <img 
                    src={ downCheron } 
                    height={ "18px" } 
                    width={ "18px" } 
                    className={`p-1 mt-1.5 transition-colors duration-200 ${
                        isDarkMode ? 'filter brightness-0 invert' : ''
                    }`}
                    alt="dropdown" 
                />
            </div>
        </div>
    )
}

export default Profile
